import { render, staticRenderFns } from "./accommodationsComponents.vue?vue&type=template&id=e1637072&scoped=true"
import script from "./accommodationsComponents.vue?vue&type=script&lang=js"
export * from "./accommodationsComponents.vue?vue&type=script&lang=js"
import style0 from "./accommodationsComponents.vue?vue&type=style&index=0&id=e1637072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1637072",
  null
  
)

export default component.exports